export interface ShipmentMethod {
    code: ShipmentType;
    title: string;
    description: string;
    cost: number;
}

export enum ShipmentType {
    FlatRate = 'flat_rate',
    FreeShipping = 'free_shipping',
    LocalPickup = 'local_pickup'
}
